<manage-wrapper
  *ngIf="!!program"
  [canEditMain]="is_program && !is_readonly"
  [topToggleText]="(program.programConfirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
  [topToggled]="!!program.programConfirmed"
  [entityTitle]="program.title"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [focusTitle]="data.focusTitle || false"
  [readOnly]="is_readonly"
  [labels]="program.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this ' + uiService.programTerm.btn"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [type]="'program'"
  [titlePlaceholder]="'Click to add a '+ uiService.programTerm.text +' nickname'"
  backgroundColor="#8270DB"
  [dialogTitle]="'Manage ' + uiService.programTerm.btn"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateProgramTitle($event)"
  (onToggle)="toggleProgramConfirmed()"
  (onDuplicate)="duplicate()"
  (onDelete)="delete()"
>
  <program-basics *ngIf="(!selectedTab || selectedTab?.id === programTabs.basics) && !!program && !!event" 
    [event]="event"
    [program]="program"
    (dateChanged)="dateChanged=true"
  ></program-basics>
  <ng-container *ngIf="selectedTab?.id === programTabs.assets">
    <assets
      [assetIds]="program.assetIds || []" 
      [entityHolderName]="'program'"
      [title]="'Room/Location Assets'"
      [readOnly]="is_readonly"
      (idsAdded)="saveAssetIds($event)"
      (idRemoved)="removeAssetId($event)"
    ></assets>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === programTabs.setup">
    <expanding-wrapper *ngFor="let setup of (program?.setupIds || []) | idsToItems:program?.setups || {}; index as setupIndex; trackBy: trackById" 
      style="margin-top: 20px; display: block;"
      [borderGreyOnCollapse]="true"
      [manualToggle]="true"
      [title]="setup.name || ('Unnamed Setup ' + (setupIndex + 1))"
      [expandedState]="openSetups[setup.id] ? 'expand' : 'collapse'"
      (onToggle)="openSetups[setup.id] = !openSetups[setup.id]"
      >

        <div *ngIf="!openSetups[setup.id] && !!setup.expected" class="header-middle expected">Expected Numbers: {{ setup.expected }}</div>
        <div *ngIf="!openSetups[setup.id] && !!setup.setup" class="header-right setup">Setup: {{ setup.setup }}</div>
    
      <program-setup [ngClass]="{ latter: !!setupIndex}" 
        [setup]="setup" 
        [program]="program"
        [readOnly]="is_readonly"
      >
        <delete-button class="setup" [deleteTitle]="'Delete ' + setup.name" [deleteText]="'This setup will be permanently deleted.'" (delete)="deleteSetup(setup.id)"></delete-button>
      </program-setup>
    </expanding-wrapper> 
    <button class="setup secondary" (click)="addSetup()">+ ADD SETUP</button>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === programTabs.exhibitorStands">
    <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: false}"></ng-container>
    <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === programTabs.tagging">
    Tag people to this {{ uiService.programTerm.btn_lower }} so all of its sessions appears in their on site schedule timeline, schedule or brief.
    <program-tag-panel [program]="program" [readOnly]="is_readonly"></program-tag-panel>
  </ng-container>
</manage-wrapper>

<ng-template #exhibitorStandsTemplate let-mobile="mobile">
  <exhibitor-stands [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [displayType]="mobile ? exhibitorDisplayTypes.narrowPod : exhibitorDisplayTypes.widePod"
    [readOnly]="is_readonly"
    [programId]="program.id"
    [emptyText]="'No exhibitor stands in this program'"
  ></exhibitor-stands>
</ng-template>
